const isTopWindow = () => {
  try {
    return window.self === window.top
  } catch {
    return false
  }
}

export default isTopWindow
